import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from "react-helmet-async";
function ProductDetail2() {
  const [active, setActive] = useState("Safe Area");
  const navigate = useNavigate();
  return (
    <>
    <Helmet>
    <title>
        Junction Boxes & Electrical Enclosures UAE | IP66 IP67 IP68 | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides IP66, IP67 and IP68 junction boxes and electrical enclosures for safe and hazardous areas in the UAE, including aluminium, FRP, GRP, stainless steel and Ex-rated solutions."
    />

    <meta
        name="keywords"
        content="junction boxes UAE, electrical enclosures UAE, IP66 junction box UAE, IP67 junction box UAE, IP68 junction box UAE, hazardous area junction boxes UAE, Ex d junction boxes UAE, Ex e terminal boxes UAE, aluminium enclosures UAE, FRP enclosures UAE, GRP enclosures UAE, stainless steel enclosures UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/product-detail"
    />

    <meta
        property="og:title"
        content="Junction Boxes & Electrical Enclosures UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Explore reliable IP66, IP67 and IP68 junction boxes, electrical enclosures and hazardous area Ex-rated solutions from Al Ibtekar in the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/product-detail"
    />

    <meta
        property="og:type"
        content="product"
    />

    <meta
        property="og:site_name"
        content="Al Ibtekar"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Junction Boxes & Electrical Enclosures UAE | Al Ibtekar"
    />

    <meta
        name="twitter:description"
        content="IP66, IP67, IP68 and hazardous area junction boxes and electrical enclosure solutions for industrial applications in the UAE."
    />
</Helmet>
      <div className='newbanner-about newbanner-about3'>
      <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
        <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Junction Box & Enclosures</h6>
        <p className=" w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Reliable protection for electrical connections in all environments.
        </p>
      </div>
      </div>
    

               <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Junction Box & Enclosures - Safe Area</h2>
  <div className='line'></div>
                         <h3 className='text-left'>We offer Ensto & Trinity Touch cable junction boxes and enclosing solutions for the most demanding with ingress protection ratings as IP66, IP67 and IP68. To meet the local & desert climatic condition the junction boxes are 2000 hours UV tested and certified to meet ADQCC and ADM, Abu Dhabi, UAE standards. Our enclosing solutions protect your electronic and electrical component in numerous applications from various external risk factors - dust, water, moisture, impact and tampering.</h3>

               </div>
               </div>


      <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

        <div className='detail-div-left'>

          <div className='main-img'>

            <img src='/assets/upproduct1.png' />
          </div>


        </div>

        <div className='detail-div-right'>






           <div>
             <ul className="mt-4 grid grid-cols-1 gap-1">
               {[
                 "   Aluminium Enclosures",
                 "Fire Protection Junction Boxes",
                 "FRP Enclosures",
                 "GRP Enclosures",
                 "Distribution Boards",
                 "EMC Enclosures",
                
               ].map((item, i) => (
                  <li
      key={i}
      className="flex items-start gap-3 rounded-lg  bg-white px-4  transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed text-left aplus">
        {item}
      </span>
    </li>
               ))}
             </ul>
      
           </div>
       
        </div>
      </div>

            <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  {/* <h2>Junction Box & Enclosures - Safe Area</h2>
  <div className='line'></div> */}
                         <h3 className='text-left mb-[20px]'>Whether your requirement is an individual enclosure or a customized product requiring mechanical processing; mounting & assembly; wiring & installation; printing; special colour, EMC protection, third party certification we have it all.<span className=' ' style={{fontWeight:'600'}}> Introducing junction box with multi cable transit system for high density cable entries.</span></h3>
<h2>Junction Box & Enclosures - Hazardous Area</h2>
  <div className='line'></div>

<h3 className='text-left'>The offering includes various types of terminals and junction boxes, that are applicable for signal and power distribution networks in hazardous area. Types of explosion protection includes Ex e, Ex ja, Ex to and Ex op pr for installation in Zones 1/21 and Zone 2/22. Options from various available sizes and matching system accessories enables custom configurations ensuring optimal solution even in extreme environmental conditions, based upon the latest international quality and safety standards. The solution is available in Glass Fiber Reinforced Polyester, Stainless Steel 316/316L, Aluminium, Aluminium Alloy - Epoxy Coated etc.</h3>

               </div>
               </div>
    <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

        <div className='detail-div-left'>
       
          <div className='main-img'>

            <img src='/assets/in2.png' />
          </div>


        </div>

        <div className='detail-div-right'>










           <div>
             <ul className="mt-4 grid grid-cols-1 gap-1">
               {[
                 "  Terminal Boxes (Ex e)",
                 "Terminal Boxes (Ex d IIB+H2)",
                 "Terminal Boxes (Ex d IIC)",
                 "Terminal Boxes (Ex d)",
                 "Control Units (Ex e)",
                
               ].map((item, i) => (
                  <li
      key={i}
      className="flex items-start gap-3 rounded-lg  bg-white px-4 transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed text-left aplus">
        {item}
      </span>
    </li>
               ))}
             </ul>
       
             <Link to="/product">
               <button className="backbtn mt-6">
                 Back To Products
               </button>
             </Link>
           </div>
       
        </div>
      </div>

<br/>
<br/>


    </>

  )
}

export default ProductDetail2